import { App, Plugin } from 'vue';
import {
  NButton,
  NTextInput,
  NSelect,
  NToggle,
  NBadge,
  NNumberInput,
  NRadioButtons,
  NCheckbox,
  NCheckboxGroup,
  NColourPicker,
  NTooltip,
  NButtonGroup,
  NReadOnlyInput,
  NSplitInputButton,
  NDataTable,
  NDatePicker,
  NIcon,
  NConversation,
  NConversationThread,
  NEmojiPicker,
  NModal,
  NApp,
  NAvatar,
  NLoadingSpinner,
} from './components';

const components = [
  NButton,
  NTextInput,
  NSelect,
  NToggle,
  NBadge,
  NNumberInput,
  NRadioButtons,
  NCheckbox,
  NCheckboxGroup,
  NColourPicker,
  NTooltip,
  NButtonGroup,
  NReadOnlyInput,
  NSplitInputButton,
  NDataTable,
  NDatePicker,
  NIcon,
  NConversation,
  NConversationThread,
  NEmojiPicker,
  NLoadingSpinner,
  NModal,
  NApp,
  NAvatar,
];

const ComponentLibrary: Plugin = {
  install(app: App, options = {}) {
    components.forEach((component) => {
      if (component?.name) {
        app.component(component.name, component);
      } else {
        console.warn('Skipping component due to missing name or undefined:', component);
      }
    });
  },
};

export default ComponentLibrary;

export {
  NButton,
  NTextInput,
  NSelect,
  NToggle,
  NBadge,
  NNumberInput,
  NCheckbox,
  NCheckboxGroup,
  NColourPicker,
  NRadioButtons,
  NTooltip,
  NButtonGroup,
  NReadOnlyInput,
  NSplitInputButton,
  NDataTable,
  NDatePicker,
  NIcon,
  NConversation,
  NConversationThread,
  NEmojiPicker,
  NModal,
  NApp,
  NAvatar,
};
